export default "__VITE_ASSET__e80649ec__"